import { useCallback, useState } from 'react';

import { css } from '@emotion/react';
import { IconButton, IconButtonProps, TextField } from '@mui/material';
import {
  CrispService,
  RouteLink,
  Types,
  useAmplifyServiceContext,
  useEventDeletePost,
  useTranslation,
} from '@scorenco/core';
import { useSnackbar } from 'notistack';

import { IconArrowDown } from '../../../icons';
import {
  DropDownProvider,
  DropDownMenu,
  DropDownMenuItem,
  useDropDownTriggerProps,
} from '../../../primitives';
import { T_KEYS } from '../../../translations';

const EventPostActionItemMenuTrigger = (props: IconButtonProps) => {
  const triggerProps = useDropDownTriggerProps();

  return (
    <IconButton {...triggerProps} {...props} size="small">
      <IconArrowDown />
    </IconButton>
  );
};

type EventPostActionItemMenuProps = IconButtonProps & {
  post: Types.Lives_Post;
  eventId?: Number;
  live?: Types.Lives_Live;
  event?: Types.Competitions_Event_Detail;
};

export const EventPostActionItemMenu = ({
  post,
  eventId,
  // live,
  // event,
  ...rest
}: EventPostActionItemMenuProps) => {
  const { t } = useTranslation();
  const deletePost = useEventDeletePost();
  const { user } = useAmplifyServiceContext();
  const { enqueueSnackbar } = useSnackbar();
  const [showReport, setShowReport] = useState(false);
  const [reportReason, setReportReason] = useState<string>('');

  const reportCrisp = useCallback(() => {
    CrispService.reportComment({
      post: post!,
      url: process.env.NEXT_PUBLIC_MOBILE_URL + '/events/' + eventId,
      reason: reportReason,
    });
  }, [post, eventId, reportReason]);
  return (
    <DropDownProvider>
      <EventPostActionItemMenuTrigger {...rest} />
      <DropDownMenu>
        {user?.info?.is_superuser && (
          <RouteLink
            href={`https://back.scorenco.com/users/admin/users/user/?id=${post?.spectator?.user_id}`}
          >
            <a target="_blank">
              <DropDownMenuItem>
                Bloquer l'utilisateur ({post?.spectator?.name})
              </DropDownMenuItem>
            </a>
          </RouteLink>
        )}

        {!showReport ? (
          <>
            {/* Pour l'instant, la modification d'actions met mal à jour le score */}
            {/* {post?.spectator?.user_id === user?.info?.id && (
              <EventAddActionMenu
                live={live}
                sport={event?.sport?.slug}
                event={event}
                post={post}
              >
                <DropDownMenuItem>Modifier</DropDownMenuItem>
              </EventAddActionMenu>
            )} */}
            <DropDownMenuItem
              closeOnClick={false}
              onClick={() => {
                setShowReport(true);
              }}
            >
              Signaler
            </DropDownMenuItem>
            {/* <DropDownMenuItem>{t(T_KEYS.EVENT_POST_COMMENT_MODIFY)}</DropDownMenuItem> */}
            {(user?.info?.is_superuser ||
              post?.spectator?.user_id == user?.info?.id) && (
              <DropDownMenuItem
                onClick={() => {
                  deletePost.call({
                    variables: { postId: post.id },
                  });
                }}
              >
                {t(T_KEYS.EVENT_POST_ACTION_DELETE)}
              </DropDownMenuItem>
            )}
          </>
        ) : reportReason == '' ? (
          <>
            <DropDownMenuItem
              closeOnClick={false}
              onClick={() => {
                setReportReason('Score ou action incorrect(e)');
              }}
            >
              Score ou action incorrect(e)
            </DropDownMenuItem>
            <DropDownMenuItem
              closeOnClick={false}
              onClick={() => {
                setReportReason('Commentaire inapproprié');
              }}
            >
              Commentaire inapproprié
            </DropDownMenuItem>
            <DropDownMenuItem
              closeOnClick={false}
              onClick={() => {
                setReportReason('Spam');
              }}
            >
              Spam
            </DropDownMenuItem>
            <DropDownMenuItem
              closeOnClick={false}
              onClick={() => {
                setReportReason('Autre : ');
              }}
            >
              Autre
            </DropDownMenuItem>
          </>
        ) : (
          <>
            {reportReason.startsWith('Autre : ') && (
              <DropDownMenuItem closeOnClick={false}>
                <TextField
                  label="Raison"
                  variant="outlined"
                  value={reportReason}
                  onChange={(e) =>
                    setReportReason(
                      'Autre : ' + e.target.value.replace('Autre : ', '')
                    )
                  }
                />
              </DropDownMenuItem>
            )}
            <DropDownMenuItem>
              Confirmez-vous que ce texte, cette action ou image soit
              problématique ?
            </DropDownMenuItem>
            <DropDownMenuItem
              onClick={async () => {
                try {
                  await reportCrisp();
                  enqueueSnackbar('Signalement envoyé', {
                    variant: 'success',
                  });
                  setShowReport(false);
                  setReportReason('');
                } catch (e) {
                  enqueueSnackbar("Erreur lors de l'envoi du signalement", {
                    variant: 'error',
                  });
                }
              }}
              disabled={reportReason == 'Autre : ' && reportReason.length < 15}
              css={(theme) => css`
                color: ${theme.palette.success.main};
                font-weight: bold;
              `}
            >
              Confirmer
            </DropDownMenuItem>
            <DropDownMenuItem
              onClick={() => {
                setShowReport(false);
                setReportReason('');
              }}
              css={(theme) => css`
                color: ${theme.palette.error.main};
              `}
            >
              Annuler
            </DropDownMenuItem>
          </>
        )}
      </DropDownMenu>
    </DropDownProvider>
  );
};
